import {Component} from '@angular/core';
import {Route} from '../../../enum/route';

@Component({
    selector: 'hvb-footer',
    templateUrl: './hvb-footer.component.html',
    styleUrls: ['./hvb-footer.component.scss'],
    standalone: false
})
export class HvbFooterComponent {
  Route = Route;
}
